"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function arrayToTagCategory(arr) {
  return Object.freeze(arr.reduce(function (o, v) {
    var _a;

    return Object.assign(o, (_a = {}, _a[v.toLocaleLowerCase()] = true, _a));
  }, {}));
}

exports.metaDataTagCategory = arrayToTagCategory(['base', 'head', 'link', 'meta', 'style', 'title']);
exports.contentSectioningTagCategory = arrayToTagCategory(['address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'main', 'nav', 'section']);
exports.textContentTagCategory = arrayToTagCategory(['blockquote', 'dd', 'dir', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul']);
exports.inlineTextSemanticTagCategory = arrayToTagCategory(['a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'tt', 'u', 'var', 'wbr']);
exports.multimediaTagCategory = arrayToTagCategory(['area', 'audio', 'img', 'map', 'track', 'video']);
exports.embeddedContentTagCategory = arrayToTagCategory(['applet', 'embed', 'iframe', 'noembed', 'object', 'param', 'picture', 'source']);
exports.scriptTagCategory = arrayToTagCategory(['canvas', 'noscript', 'script']);
exports.demarcatingEditTagCategory = arrayToTagCategory(['del', 'ins']);
exports.tableContentTagCategory = arrayToTagCategory(['caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr']);
exports.formTagCategory = arrayToTagCategory(['button', 'datalist', 'fieldset', 'form', 'input', 'label', 'legend', 'meter', 'optgroup', 'option', 'output', 'progress', 'select', 'textarea']);
exports.interactiveTagCategory = arrayToTagCategory(['details', 'dialog', 'menu', 'menuitem', 'summary']);
exports.deprecatedTagCategory = arrayToTagCategory(['acronym', 'applet', 'basefont', 'bgsound', 'big', 'blink', 'center', 'command', 'content', 'dir', 'element', 'font', 'frame', 'frameset', 'image', 'isindex', 'keygen', 'listing', 'marquee', 'menuitem', 'multicol', 'nextid', 'nobr', 'noembed', 'noframes', 'plaintext', 'shadow', 'spacer', 'strike', 'tt', 'xmp']);
exports.selfClosingTagCategory = arrayToTagCategory(['br', 'img', 'col', 'hr']);
exports.blockTagCategory = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, exports.contentSectioningTagCategory), exports.textContentTagCategory), exports.multimediaTagCategory), exports.embeddedContentTagCategory), exports.tableContentTagCategory), exports.formTagCategory), exports.selfClosingTagCategory);
exports.inlineTagCategory = __assign(__assign({}, exports.inlineTextSemanticTagCategory), {
  br: undefined,
  code: undefined
});

function isElementNode(node) {
  return !!node && node.nodeType === Node.ELEMENT_NODE;
}

exports.isElementNode = isElementNode;

function isTextNode(node) {
  return !!node && node.nodeType === Node.TEXT_NODE;
}

exports.isTextNode = isTextNode;

function isCommentNode(node) {
  return !!node && node.nodeType === Node.COMMENT_NODE;
}

exports.isCommentNode = isCommentNode;

function isBlockNode(node) {
  return isElementNode(node) && !!exports.blockTagCategory[node.tagName.toLocaleLowerCase()];
}

exports.isBlockNode = isBlockNode;

function isInlineNode(node) {
  return isElementNode(node) && !!exports.inlineTagCategory[node.tagName.toLocaleLowerCase()];
}

exports.isInlineNode = isInlineNode;

function isSelfClosingNode(node) {
  return isElementNode(node) && !!exports.selfClosingTagCategory[node.tagName.toLocaleLowerCase()];
}

exports.isSelfClosingNode = isSelfClosingNode;